"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.formatTransaction = void 0;
var bignumber_js_1 = require("bignumber.js");
var common_1 = require("../../transaction/common");
var account_1 = require("../../account");
var currencies_1 = require("../../currencies");
var formatTransaction = function (_a, mainAccount) {
    var mode = _a.mode, subAccountId = _a.subAccountId, amount = _a.amount, recipient = _a.recipient, fees = _a.fees, useAllAmount = _a.useAllAmount;
    var account = (subAccountId &&
        (mainAccount.subAccounts || []).find(function (a) { return a.id === subAccountId; })) ||
        mainAccount;
    return "\n    ".concat(mode === "claimReward"
        ? "CLAIM REWARD"
        : mode === "optIn"
            ? "OPT_IN"
            : "SEND", " ").concat(useAllAmount
        ? "MAX"
        : (0, currencies_1.formatCurrencyUnit)((0, account_1.getAccountUnit)(account), amount, {
            showCode: true,
            disableRounding: false
        }), "\n    TO ").concat(recipient, "\n    with fees=").concat(!fees
        ? "?"
        : (0, currencies_1.formatCurrencyUnit)((0, account_1.getAccountUnit)(mainAccount), fees, {
            showCode: true,
            disableRounding: false
        }));
};
exports.formatTransaction = formatTransaction;
var fromTransactionRaw = function (tr) {
    var common = (0, common_1.fromTransactionCommonRaw)(tr);
    return __assign(__assign({}, common), { family: tr.family, fees: tr.fees ? new bignumber_js_1.BigNumber(tr.fees) : null, memo: tr.memo, mode: tr.mode, assetId: tr.assetId });
};
var toTransactionRaw = function (t) {
    var common = (0, common_1.toTransactionCommonRaw)(t);
    return __assign(__assign({}, common), { family: t.family, fees: t.fees ? t.fees.toString() : null, memo: t.memo, mode: t.mode, assetId: t.assetId });
};
exports["default"] = {
    formatTransaction: exports.formatTransaction,
    fromTransactionRaw: fromTransactionRaw,
    toTransactionRaw: toTransactionRaw
};
//# sourceMappingURL=transaction.js.map